import { Box, chakra } from "@chakra-ui/react";

export const StyledDashboardLayoutChildContainer = chakra(Box, {
  baseStyle: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderColor: "gray.600",
  },
});
